import React, {lazy} from "react"


export const useLazy = (imp: any, key: string) => {
    return lazy(() =>
        imp.then(module => (
            { default: module[key] }
        ))
    )
}